document.addEventListener("variant-changed", (e) => {
    const variant = e.detail;
    if (!variant) return;

    document.querySelectorAll(".bundle-promo-banner").forEach((banner) => {
        const map = banner.dataset.variantSavings;
        if (!map) return;

        let savings;
        try {
            savings = JSON.parse(map);
        } catch (err) {
            return;
        }

        const amountEl = banner.querySelector("[data-bundle-amount]");
        const next = savings[variant.id];
        if (amountEl && next != null) {
            amountEl.textContent = `$${next}`;
        }
    });
});
